import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/ja_aktiv.svg'
import _imports_1 from '@/assets/img/nein_aktiv.svg'
import _imports_2 from '@/assets/img/silverware_variant_icon_137189.svg'


const _withScopeId = n => (_pushScopeId("data-v-64560628"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"{padding":"5rem, position: relativ"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "productInfo" }
const _hoisted_4 = { style: {"padding":"0.5rem"} }
const _hoisted_5 = {
  key: 0,
  style: {"font-style":"italic"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "sizeIndicator"
}
const _hoisted_10 = { class: "sizeIndicator" }
const _hoisted_11 = { class: "lamp" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"1rem"} }, "|", -1))
const _hoisted_15 = { class: "sizeIndicator" }
const _hoisted_16 = { class: "lamp" }
const _hoisted_17 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_18 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_19 = {
  style: {"display":"flex"},
  class: "actions"
}
const _hoisted_20 = { class: "container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  checked: false,
  type: "checkbox"
}, null, -1))
const _hoisted_22 = { viewBox: "0 0 256 256" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  fill: "none",
  height: "256",
  width: "256"
}, null, -1))
const _hoisted_24 = ["stroke"]
const _hoisted_25 = { class: "container" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = { viewBox: "0 0 145 145" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  fill: "none",
  height: "145",
  width: "145"
}, null, -1))
const _hoisted_29 = ["fill"]
const _hoisted_30 = {
  key: 0,
  class: "mealMatchInfo"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeedbackOverlay = _resolveComponent("FeedbackOverlay")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["productCard", {
    notAvailable: !_ctx.isProductAvailable,
    chatbot: _ctx.stylingVariant === 'CHATBOT',
  }])
  }, [
    (_ctx.isFeedbackOverlayVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_FeedbackOverlay, {
            onCloseClick: _cache[0] || (_cache[0] = () => { _ctx.isFeedbackOverlayVisible = false; _ctx.dislike = false }),
            onFeedbackReasonSelected: _ctx.sendFeedback,
            reasonArray: _ctx.dislikeFeedbackReasons,
            widthBlur: '90%',
            heightBlur: "60%",
            borderRadius: "50px",
            company: _ctx.company
          }, null, 8, ["onFeedbackReasonSelected", "reasonArray", "company"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "productImage",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('productImageClicked', _ctx.product)))
    }, [
      (_ctx.product.PictureFront)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.product.PictureFront
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.product.Name), 1),
        (_ctx.product.Phonetic)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " [" + _toDisplayString(_ctx.product.Phonetic) + "] ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.product.Grape), 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.product.Country), 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.company.DisplayedTexts[_ctx.product.Category] ?? _ctx.product.Category), 1),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.company.CompanyQuizConfig.ShowSizeIndicator)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.company.CompanyQuizConfig.SizeIndicatorGlassText ?? "0,25 L") + " ", 1),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.product.AvailableByglass)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                    : (_openBlock(), _createElementBlock("img", _hoisted_13))
                ])
              ]),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createTextVNode(" 0,75 L "),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.product.AvailableBybottle)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                    : (_openBlock(), _createElementBlock("img", _hoisted_18))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.company.CompanyQuizConfig.BTGMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('productClicked', _ctx.product))),
                class: "productButton",
                style: {"padding-top":"1rem","padding-bottom":"1rem","min-height":"32px"}
              }, [
                _createElementVNode("a", null, _toDisplayString(_ctx.btgButtonText), 1)
              ]))
            : (_ctx.stylingVariant !== 'CHATBOT' || _ctx.product.Handle)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('productClicked', _ctx.product))),
                  class: _normalizeClass(["productButton", { chatbot: _ctx.stylingVariant === 'CHATBOT' }]),
                  style: {"padding-top":"1rem","padding-bottom":"1rem","min-height":"32px"}
                }, [
                  _createElementVNode("a", null, _toDisplayString(_ctx.productButtonText) + " " + _toDisplayString(_ctx.stylingVariant === "CHATBOT" ? "→" : ""), 1)
                ], 2))
              : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", {
              class: "checkmark",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendFeedback()))
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("path", {
                  d: "M224.6,51.9a59.5,59.5,0,0,0-43-19.9,60.5,60.5,0,0,0-44,17.6L128,59.1l-7.5-7.4C97.2,28.3,59.2,26.3,35.9,47.4a59.9,59.9,0,0,0-2.3,87l83.1,83.1a15.9,15.9,0,0,0,22.6,0l81-81C243.7,113.2,245.6,75.2,224.6,51.9Z",
                  "stroke-width": "20px",
                  stroke: _ctx.company.FrontendDesign?.ProductWizard?.SecondaryColor ??
                    '#000000'
                    ,
                  fill: "none"
                }, null, 8, _hoisted_24)
              ]))
            ])
          ]),
          _createElementVNode("label", _hoisted_25, [
            _createElementVNode("input", {
              checked: false && _ctx.dislike,
              type: "checkbox"
            }, null, 8, _hoisted_26),
            _createElementVNode("div", {
              class: "remove",
              onClick: _cache[5] || (_cache[5] = () => {
              _ctx.isFeedbackOverlayVisible = _ctx.dislike === false;
            })
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("path", {
                  d: "M72.0833 0C32.2212 0 0 32.2212 0 72.0833C0 111.945 32.2212 144.167 72.0833 144.167C111.945 144.167 144.167 111.945 144.167 72.0833C144.167 32.2212 111.945 0 72.0833 0ZM108.125 97.9613L97.9613 108.125L72.0833 82.2471L46.2054 108.125L36.0417 97.9613L61.9196 72.0833L36.0417 46.2054L46.2054 36.0417L72.0833 61.9196L97.9613 36.0417L108.125 46.2054L82.2471 72.0833L108.125 97.9613Z",
                  fill: _ctx.company.FrontendDesign?.ProductWizard?.SecondaryColor
                }, null, 8, _hoisted_29)
              ]))
            ])
          ])
        ])
      ]),
      (_ctx.product.MealMatch > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
        : _createCommentVNode("", true)
    ])
  ], 2))
}